import React, { useContext } from 'react';

import { excApi, handleApiCall } from '@exchange-frontends/api';
import { useIsMounted, useSelectedOrg } from '@exchange-frontends/custom-hooks';

import { useStore } from '../../../store';
import { UserDataContext } from '../../App';
import AcquireAppButton from './AcquireAppButton';

const prepareContextualStoreFront = async (data, pricingInfo, profile) => {
  window.fastspring.builder.tag({ referrer: data });
  window.fastspring.builder.push({
    products: [
      {
        path: pricingInfo.buyUrl,
        quantity: 1,
      },
    ],
    paymentContact: {
      email: profile?.email,
      firstName: profile?.first_name,
      lastName: profile?.last_name,
    },
    checkout: true,
  });
};

const EcPaidAppButton = () => {
  const { profile, accessToken } = useContext(UserDataContext) ?? {};
  const selectedOrg = useSelectedOrg();
  const isMounted = useIsMounted();
  const detailScreen = useStore((state) => state.detailScreen);
  const { appType, pricingInfo, id: appId } = detailScreen ?? {};
  const versionId = detailScreen?.appVersionId;

  const acquirePaidEnterpriseEntitlement = async () => {
    const orgId = selectedOrg?.code;
    const handler = handleApiCall(excApi.generateUniqueIdV2, {
      appId,
      orgId,
      versionId,
      appType,
      accessToken,
    });

    const response = await handler.run();
    if (isMounted.current) {
      if (response.error) {
        console.error('response.error', response.error);
      } else {
        prepareContextualStoreFront(response, pricingInfo, profile);
      }
    }
  };

  return <AcquireAppButton type="paid" onPress={acquirePaidEnterpriseEntitlement} />;
};

export default EcPaidAppButton;
